import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragulaModule } from 'ng2-dragula';

import { NutritionViewLeafModule } from '../nutrition-view-leaf/nutrition-view-leaf.module';
import { NutritionViewListNodeComponent } from './nutrition-view-list-node.component';

@NgModule({
  declarations: [NutritionViewListNodeComponent],
  imports: [CommonModule, DragulaModule, NutritionViewLeafModule],
  exports: [NutritionViewListNodeComponent],
})
export class NutritionViewListNodeModule {}
